'use client';

import { __assign } from '../../_virtual/_tslib.js';
import { createContext } from 'react';
import { initialBarChart } from './index.js';

var barChartReducer = function (state, action) {
    var type = action.type, payload = action.payload;
    switch (type) {
        case 'UPDATE_TOOLTIP_POSITION':
            return __assign(__assign({}, state), { tooltip: {
                    x: payload.x || 0,
                    y: payload.y || 0
                } });
        default:
            console.error('Unknown type of BarChart Reducer');
            return __assign({}, state);
    }
};
var BarChartContext = createContext({
    barChartState: initialBarChart,
    dispatch: function () { }
});

export { BarChartContext, barChartReducer };
//# sourceMappingURL=reducer.js.map
